import script from "./InputRadio.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputRadio.vue?vue&type=script&lang=ts&setup=true"

import "./InputRadio.vue?vue&type=style&index=0&id=60aad523&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60aad523"]])

export default __exports__